import { useState } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Lang } from "./i18n/translations";
import Layout from "./components/Layout";
import Hero from "./components/Hero";
import HowItWorks from "./components/HowItWorks";
import Apps from "./components/Apps";
import Why from "./components/Why";
import FAQ from "./components/FAQ";
import Support from "./components/Support";
import "./App.css";

export default function App() {
  const [lang, setLang] = useState<Lang>("pt");
  const toggleLang = () => setLang((l) => (l === "pt" ? "en" : "pt"));

  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={
          <Layout lang={lang} onToggleLang={toggleLang}>
            <Hero lang={lang} />
            <HowItWorks lang={lang} />
            <Apps lang={lang} />
            <Why lang={lang} />
            <FAQ lang={lang} />
          </Layout>
        } />
        <Route path="/apoie" element={
          <Layout lang={lang} onToggleLang={toggleLang} variant="support">
            <Support lang={lang} />
          </Layout>
        } />
        <Route path="/support" element={
          <Layout lang={lang} onToggleLang={toggleLang} variant="support">
            <Support lang={lang} />
          </Layout>
        } />
      </Routes>
    </HashRouter>
  );
}
